import React from "react";
import GenericMasterPage from "@/pages/GenericMasterPage";

export default function ProvidersPage() {
  return (
    <GenericMasterPage
      resourcePath="providers"
      testIdPrefix="provider"
      title="SIM Service Provider"
      description="Telecom SIM providers used for activations. A provider can have multiple account numbers."
      fields={[
        { key: "name", label: "Provider Name", required: true, placeholder: "e.g. Airtel, Jio, Vodafone" },
        { key: "account_number", label: "Account Number", required: true, placeholder: "e.g. AC-7821" },
      ]}
      displayKeys={["name", "account_number"]}
    />
  );
}
